/* eslint-disable jsx-a11y/anchor-is-valid */
// NPM imports
import React from "react";

function PrivacyPolicyFooter(props) {
  const openSharingSettings = event => {
    event.preventDefault();
    window?.OneTrust?.ToggleInfoDisplay(); // Update window type
  };

  return (
    <div
      className={`privacy-policy-footer ${
        props.docStage === "COMPLETED" ? "privacy-policy-footer-completed" : ""
      }
      ${props.isShared ? "privacy-policy-footer-shared" : ""}
        ${props.isAgreed ? "privacy-policy-footer-agreed" : ""}`}>
      <a
        id="footer-terms-of-service"
        className="underline text-black font-normal"
        href="https://www.legalzoom.com/legal/general-terms/terms-of-use"
        data-test="privacy-policy-footer-terms-of-service"
        target="_blank"
        rel="noreferrer">
        Terms of Use{" "}
      </a>
      {"|"}
      <a
        id="footer-privacy-policy"
        className="underline text-black font-normal"
        href="https://www.legalzoom.com/legal/general-terms/privacy-policy"
        data-test="privacy-policy-footer-privacy-policy"
        target="_blank"
        rel="noreferrer">
        {" "}
        Privacy Policy{" "}
      </a>
      {"|"}
      <a
        id="footer-cookie-info"
        className="underline text-black font-normal"
        data-test="privacy-policy-footer-cookie-info"
        href="#"
        onClick={event => openSharingSettings(event)}>
        {" "}
        My information sharing settings
      </a>
    </div>
  );
}

export default PrivacyPolicyFooter;
